import { render, staticRenderFns } from "./menu-button-v2.vue?vue&type=template&id=4cf09f20&scoped=true&"
import script from "./menu-button-v2.vue?vue&type=script&lang=js&"
export * from "./menu-button-v2.vue?vue&type=script&lang=js&"
import style0 from "./menu-button-v2.vue?vue&type=style&index=0&id=4cf09f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf09f20",
  null
  
)

export default component.exports